import { render, staticRenderFns } from "./LabeledTooltip.vue?vue&type=template&id=72035770&scoped=true&"
import script from "./LabeledTooltip.vue?vue&type=script&lang=ts&"
export * from "./LabeledTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./LabeledTooltip.vue?vue&type=style&index=0&id=72035770&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72035770",
  null
  
)

export default component.exports